import {Suspense, SuspenseProps} from 'react';
import {ComponentWithRequiredChildren, PropsWithRequiredChildren} from '../react/types';
import {ErrorBoundary, ErrorBoundaryProps} from './ErrorBoundary';
import {Loading} from './Loading';

type ComponentBoundaryProps = PropsWithRequiredChildren<ErrorBoundaryProps & Pick<SuspenseProps, 'fallback'>>;

export const ComponentBoundary: ComponentWithRequiredChildren<ComponentBoundaryProps> = ({
  children,
  fallback = <Loading />,
  ...errorBoundaryProps
}: ComponentBoundaryProps) => {
  return (
    <ErrorBoundary {...errorBoundaryProps}>
      <Suspense fallback={fallback}>{children}</Suspense>
    </ErrorBoundary>
  );
};
